import { Pagination, PaginationItem } from '@mui/material';
import React from 'react';
import { NextButtonFunc, PrevButtonFunc } from './PrevNextButton';
import { isMobile } from 'react-device-detect';

const MuiPagination = (props) => (
	<Pagination
		variant="outlined"
		shape="rounded"
		size={isMobile ? "small" : "medium"}
		renderItem={(itemProps) => (
			<PaginationItem slots={{ previous: PrevButtonFunc, next: NextButtonFunc }} {...itemProps} />
		)}
		{...props}
		boundaryCount={isMobile ? 0 : 1}
		siblingCount={isMobile ? 0 : 1}
	/>
);

export default MuiPagination;
